import { render } from "./Annotation.vue?vue&type=template&id=9dcadb74&scoped=true"
import script from "./Annotation.vue?vue&type=script&lang=js"
export * from "./Annotation.vue?vue&type=script&lang=js"

import "./Annotation.vue?vue&type=style&index=0&id=9dcadb74&lang=scss&scoped=true"
import "./Annotation.vue?vue&type=style&index=1&id=9dcadb74&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dcadb74"]])

export default __exports__